import modelFieldMessages from './modelFieldMessages';

const numBoards = {
  key: 'numBoards',
  type: 'string',
  title: modelFieldMessages.identifierNumBoards
};
const lamellaLength = {
  key: 'lamellaLength',
  type: 'string',
  title: modelFieldMessages.lamellaLength
};
const supplierBatchId = {
  key: 'supplierBatchId',
  type: 'string',
  title: modelFieldMessages.supplierBatchId
};
const moisture = {
  key: 'moisture',
  type: 'string',
  title: modelFieldMessages.moisture
};
const sawMill = {
  key: 'sawMill',
  type: 'string',
  title: modelFieldMessages.sawMill
};
// const clientId = {
//   key: 'clientId',
//   type: 'string',
//   title: modelFieldMessages.clientId
// };
class IncomingPackage {
  static fields = {
    compartmentId: {
      key: 'id',
      type: 'arrayindex',
      title: modelFieldMessages.compartment
    },
    id: {
      key: 'id',
      type: 'string',
      title: modelFieldMessages.id
    },
    cartId: {
      key: 'cartId',
      type: 'string',
      title: modelFieldMessages.cartId
    },
    number: {
      key: 'number',
      type: 'string',
      title: modelFieldMessages.id
    },
    makkonId: {
      key: 'makkonId',
      type: 'string',
      title: modelFieldMessages.makkonId
    },
    strengthGrade: {
      key: 'strengthGrade',
      type: 'string',
      title: modelFieldMessages.grade
    },
    rawLamellaId: {
      key: 'rawLamellaId',
      type: 'string',
      title: modelFieldMessages.id
    },
    noLengthFinalDimensions: {
      key: 'noLengthDimensions',
      title: modelFieldMessages.finalDimension,
      format: {
        type: 'object_from_many',
        str: '{lamellaThickness} x {lamellaWidth} mm',
        keys: ['lamellaThickness', 'lamellaWidth']
      }
    },
    subPackages: {
      key: 'subPackages',
      type: 'ListViewAdd',
      // label: modelFieldMessages.sortedOutputData,
      format: [supplierBatchId, sawMill, lamellaLength, numBoards, moisture],
      title: modelFieldMessages.subPackages
    },
    cutListSent: {
      key: 'cutListSent',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.cutListSent
    },
    fullyUsed: {
      key: 'fullyUsed',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.fullyUsed
    },
    fullyUsedSent: {
      key: 'fullyUsedSent',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.fullyUsedSent
    },
    shouldBeRemoved: {
      key: 'shouldBeRemoved',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.shouldBeRemoved
    },
    shouldBeRemovedSent: {
      key: 'shouldBeRemovedSent',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.shouldBeRemovedSent
    },
    productStacked: {
      key: 'productStacked',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.productStacked
    },
    processed: {
      key: 'processed',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.processed
    },
    sentToDB: {
      key: 'sentToDB',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.sentToDB
    },
    passedBanner: {
      key: 'passedBanner',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.passedBanner
    },
    goodWood: {
      key: 'goodWood',
      format: {
        type: 'string'
      },
      title: modelFieldMessages.goodWood
    },
    badWood: {
      key: 'badWood',
      format: {
        type: 'string'
      },
      title: modelFieldMessages.badWood
    },
    cutList: {
      key: 'cutList',
      type: 'arraylength',
      title: modelFieldMessages.cutList
    },
    rawLamellaIdentifier: {
      key: 'rawLamellaIdentifier',
      type: 'string',
      title: modelFieldMessages.rawLamellaIdentifier
    },
    piecesPerLayer: {
      key: 'piecesPerLayer',
      type: 'string',
      title: modelFieldMessages.piecesPerLayer,
      validation: ['float', 'aboveZero']
    },
    lamellaThickness: {
      key: 'lamellaThickness',
      type: 'string',
      title: modelFieldMessages.lamellaThickness,
      validation: ['float', 'aboveZero']
    },
    lamellaWidth: {
      key: 'lamellaWidth',
      type: 'string',
      title: modelFieldMessages.lamellaWidth,
      validation: ['float', 'aboveZero']
    },
    labelType: {
      key: 'labelType',
      type: 'string',
      title: modelFieldMessages.labelType,
      validation: ['float', 'aboveZero']
    },
    opBlock: {
      key: 'opBlock',
      type: 'string',
      title: modelFieldMessages.opBlock,
      validation: ['float', 'aboveZero']
    },
    identifier: {
      key: 'identifier',
      type: 'string',
      title: modelFieldMessages.identifier,
      blank: false
    },
    identifierSchneider: {
      key: 'identifier',
      type: 'string',
      title: modelFieldMessages.identifierSchneider,
      blank: false
    },
    order: {
      key: 'order',
      type: 'string',
      title: modelFieldMessages.order,
      blank: false
    },
    type: {
      key: 'type',
      type: 'string',
      title: modelFieldMessages.type,
      blank: false
    },
    neededOnLoadingPosition: {
      key: 'neededOnLoadingPosition',
      type: 'string',
      title: modelFieldMessages.neededOnLoadingPosition
    },
    requestedQuality: {
      key: 'requestedQuality',
      type: 'select',
      title: modelFieldMessages.requestedQuality,
      format: {
        choices: (item) => {
          const qualities = item?.materialQualityOptions?.length ? item.materialQualityOptions : ['Original quality'];
          const choices = item?.requestedQuality && !qualities.includes(item.requestedQuality) ? [...qualities, item.requestedQuality] : qualities;
          return choices.map((quality) => ({ id: quality, label: quality === 'Original quality' ? 'Original' : quality }));
        },
        identifier: 'label',
        valueKey: 'requestedQuality',
        defaultValue: 'Original quality',
        showId: false,
        disabled: (item) => !item?.requestedQuality && (item?.materialQualityOptions?.length || 0) <= 1,
        wsAction: 'select-material-quality',
        optionIdKey: 'selection'
      }
    },
    neededOnLoadingPositionDropdown: {
      key: 'neededOnLoadingPosition',
      type: 'select',
      format: {
        item: 'loadingPositions',
        identifier: 'label',
        valueKey: 'neededOnLoadingPosition',
        wsAction: 'select-loading-position',
        optionIdKey: 'position'
      },
      title: modelFieldMessages.neededOnLoadingPositionDropdown
    },
    comment: {
      key: 'comment',
      type: 'string',
      title: modelFieldMessages.comment
    },
    lmWithPaketladn: {
      key: 'lmWithPaketladn',
      title: modelFieldMessages.lmWithPaketladn,
      format: {
        type: 'object_from_many',
        str: '{{ {lmWithPaketladn} / 1000}} m',
        keys: ['lmWithPaketladn']
      }
    },
    lmWithPaketladn_schneider: {
      key: 'lmWithPaketladn',
      title: modelFieldMessages.lmWithPaketladn,
      format: {
        type: 'object_from_many',
        str: '{{ Number(({lmWithPaketladn} / 1000).toFixed(2)).toLocaleString("de-DE")}} m',
        keys: ['lmWithPaketladn']
      }
    },
    lmWithPaketladn_m3: {
      title: modelFieldMessages.lmWithPaketladn_m3,
      format: {
        type: 'object_from_many',
        str: '{{ ({lamellaThickness} * {lamellaWidth} * {lmWithPaketladn} * 0.000000001).toFixed(3)}} m3',
        keys: ['lamellaThickness', 'lamellaWidth', 'lmWithPaketladn']
      }
    },
    lmTotalNeeded: {
      key: 'lmTotalNeeded',
      title: modelFieldMessages.lmTotalNeeded,
      format: {
        type: 'object_from_many',
        str: '{{ {lmTotalNeeded} / 1000}} m',
        keys: ['lmTotalNeeded']
      }
    },

    lmWithOrderedPackages: {
      key: 'lmWithOrderedPackages',
      title: modelFieldMessages.lmWithOrderedPackages,
      format: {
        type: 'object_from_many',
        str: '{{ {lmWithOrderedPackages} / 1000}} m',
        keys: ['lmWithOrderedPackages']
      }
    },
    lmWithOrderedPackages_schneider: {
      key: 'lmWithOrderedPackages',
      title: modelFieldMessages.lmWithOrderedPackages,
      format: {
        type: 'object_from_many',
        str: '{{ Number(({lmWithOrderedPackages} / 1000).toFixed(2)).toLocaleString("de-DE")}} m',
        keys: ['lmWithOrderedPackages']
      }
    },
    splitWood: {
      key: 'canBeSplit',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.splitWood
    },
    machine: {
      key: 'machine',
      type: 'string',
      title: modelFieldMessages.machine
    },
    machineSchneider: {
      key: 'machine',
      type: 'string',
      title: modelFieldMessages.machineSchneider
    },
    averageLength: {
      key: 'averageLength',
      type: 'string',
      title: modelFieldMessages.averageLength,
      validation: ['float', 'aboveZero']
    },
    usedAt: {
      key: 'usedAt',
      title: modelFieldMessages.identifierUsedAt,
      format: {
        type: 'date'
      }
    },
    createdAt: {
      key: 'created_at',
      title: modelFieldMessages.identifierCreatedAt,
      format: {
        type: 'date'
      }
    },
    leavingAt: {
      key: 'leavingAt',
      title: modelFieldMessages.leavingAt,
      format: {
        type: 'date'
      }
    },
    createdAtCC: {
      key: 'createdAt',
      title: modelFieldMessages.identifierCreatedAt,
      format: {
        type: 'date'
      }
    },
    lineRegime: {
      key: 'line_regime',
      title: modelFieldMessages.lineRegime,
      type: 'string'
    },
    createdDate: {
      key: 'createdDate',
      title: modelFieldMessages.identifierCreatedAt,
      format: {
        type: 'date'
      }
    },
    productionDate: {
      key: 'productionDate',
      title: modelFieldMessages.identifierProductionDate,
      format: {
        type: 'date'
      }
    },
    completedDate: {
      key: 'completedDate',
      title: modelFieldMessages.completedDate,
      format: {
        type: 'date'
      }
    },
    suppliedDate: {
      key: 'identifierSuppliedDate',
      title: modelFieldMessages.identifierSuppliedDate,
      format: {
        type: 'date'
      }
    },
    suppliedDateReal: {
      key: 'suppliedDate',
      title: modelFieldMessages.identifierSuppliedDate,
      format: {
        type: 'date'
      }
    },
    numRows: {
      key: 'numRows',
      title: modelFieldMessages.identifierNumRows
    },
    quality: {
      key: 'quality',
      type: 'string',
      title: modelFieldMessages.quality
      // blank: false,
    },
    lotNumber: {
      key: 'lotNumber',
      type: 'string',
      title: modelFieldMessages.lotNumber,
      validation: ['float', 'aboveZero'],
      blank: false
    },
    packageNumber: {
      key: 'packageNumber',
      type: 'string',
      title: modelFieldMessages.packageNumber,
      validation: ['float', 'aboveZero'],
      blank: false
    },
    storage: {
      key: 'storage',
      type: 'string',
      title: modelFieldMessages.storage,
      validation: ['float', 'aboveZero'],
      blank: false
    },
    numColumns: {
      key: 'numColumns',
      title: modelFieldMessages.identifierNumColumns
    },
    numBoards: {
      key: 'numBoards',
      type: 'string',
      title: modelFieldMessages.identifierNumBoards
    },
    destination: {
      key: 'destination',
      type: 'string',
      title: modelFieldMessages.destination
    },
    lamellaLength: {
      key: 'lamellaLength',
      type: 'string',
      title: modelFieldMessages.lamellaLength,
      validation: ['float', 'aboveZero']
    },
    lm: {
      title: modelFieldMessages.lm,
      format: {
        type: 'object_from_many',
        str: '{{ {lm} / 1000}} m',
        keys: ['lm']
      }
    },
    lm_schneider: {
      // dve decimalki, vejica za vsakih 1000
      title: modelFieldMessages.lm,
      format: {
        type: 'object_from_many',
        str: '{{ Number(({lm} / 1000).toFixed(2)).toLocaleString("de-DE")}} m',
        keys: ['lm']
      }
    },
    lmConverted: {
      title: modelFieldMessages.lm,
      format: {
        type: 'conversion_from_many',
        str: '{{ ({lm} / 1000).toFixed(3) }}',
        keys: [{ key: 'lm', fromUnit: 'meters', toUnit: 'feet' }],
        fromUnitLabel: 'm',
        toUnitLabel: 'ft',
        unitType: 'length'
      }
    },
    neededFromStorageConverted: {
      title: modelFieldMessages.neededFromStorage,
      format: {
        type: 'conversion_from_many',
        str: '{{ ({neededFromStorage} / 1000).toFixed(3) }}',
        keys: [{ key: 'neededFromStorage', fromUnit: 'meters', toUnit: 'feet' }],
        fromUnitLabel: 'm',
        toUnitLabel: 'ft',
        unitType: 'length'
      }
    },
    lmWithPaketladnConverted: {
      title: modelFieldMessages.lmWithPaketladn,
      format: {
        type: 'conversion_from_many',
        str: '{{ {lmWithPaketladn} / 1000}}',
        keys: [{ key: 'lmWithPaketladn', fromUnit: 'meters', toUnit: 'feet' }],
        fromUnitLabel: 'm',
        toUnitLabel: 'ft',
        unitType: 'length'
      }
    },
    lmUsed: {
      key: 'lmUsed',
      title: modelFieldMessages.lmUsed
    },
    clientId: {
      key: 'clientId',
      type: 'string',
      title: modelFieldMessages.clientId
    },
    width: {
      key: 'lamellaWidth',
      type: 'string',
      title: modelFieldMessages.lamellaWidth,
      validation: ['float', 'aboveZero']
    },
    thickness: {
      key: 'lamellaThickness',
      type: 'string',
      input: 'number',
      title: modelFieldMessages.lamellaThickness,
      validation: ['float', 'aboveZero']
    },
    thicknessRaw: {
      key: 'thicknessRaw',
      type: 'string',
      input: 'number',
      title: modelFieldMessages.thicknessRaw,
      validation: ['float', 'aboveZero']
    },
    widthRaw: {
      key: 'widthRaw',
      type: 'string',
      title: modelFieldMessages.widthRaw,
      validation: ['float', 'aboveZero']
    },
    woodType: {
      key: 'woodType',
      type: 'string',
      title: modelFieldMessages.woodType
    },
    grade: {
      key: 'grade',
      type: 'string',
      title: modelFieldMessages.grade
    },
    materialCode: {
      key: 'materialCode',
      type: 'string',
      title: modelFieldMessages.materialCode
    },
    manuallyAdded: {
      key: 'manuallyAdded',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.manuallyAdded
    },
    rawDimensions: {
      title: modelFieldMessages.rawDimensions,
      key: 'rawDimensions',
      format: {
        type: 'object_from_many',
        str: '{lamellaThickness} x {lamellaWidth} x {lamellaLength} mm',
        keys: ['lamellaThickness', 'lamellaWidth', 'lamellaLength']
      }
    },
    rawDimensionsPeetri: {
      title: modelFieldMessages.rawDimensions,
      key: 'rawDimensions',
      format: {
        type: 'object_from_many',
        str: '{lamellaThickness} x  {lamellaWidth} x {{ {lamellaLength} * 1000 }} mm',
        keys: ['lamellaThickness', 'lamellaWidth', 'lamellaLength']
      }
    },
    rawDimensionsSodra: {
      title: modelFieldMessages.rawDimensions,
      format: {
        type: 'object_from_many',
        str: '{lamellaThickness} x {lamellaWidth} x {lamellaLength} mm',
        keys: ['lamellaThickness', 'lamellaWidth', 'lamellaLength']
      }
    },
    rawDimensionsSmartlam: {
      title: modelFieldMessages.rawDimensions,
      format: {
        type: 'conversion_from_many',
        str: '{lamellaThickness} x {lamellaWidth} x {lamellaLength} ',
        keys: [
          { key: 'lamellaThickness', fromUnit: 'millimeters', toUnit: 'inches' },
          { key: 'lamellaWidth', fromUnit: 'millimeters', toUnit: 'inches' },
          { key: 'lamellaLength', fromUnit: 'millimeters', toUnit: 'inches' }
        ],
        fromUnitLabel: 'mm',
        toUnitLabel: 'in',
        unitType: 'length'
      }
    },
    rawDimensionsSchilliger: {
      title: modelFieldMessages.rawDimensions,
      format: {
        type: 'object_from_many',
        str: '{rawLamellaThickness} x {rawLamellaWidth} mm',
        keys: ['rawLamellaThickness', 'rawLamellaWidth']
      }
    },
    dimensions: {
      title: modelFieldMessages.dimensions,
      format: {
        type: 'object_from_many',
        str: '{lamellaThickness} x {lamellaWidth} x {lamellaLength} mm',
        keys: ['lamellaThickness', 'lamellaWidth', 'lamellaLength']
      }
    },
    cubicMeters: {
      title: modelFieldMessages.package_m3,
      format: {
        type: 'object_from_many',
        str: '{cubicMeters} m3',
        keys: ['cubicMeters']
      }
    },
    package_m3: {
      title: modelFieldMessages.package_m3,
      format: {
        type: 'object_from_many',
        str: '{{ ({lamellaThickness} * {lamellaWidth} * {lm} * 0.000000001).toFixed(3)}} m3',
        keys: ['lamellaThickness', 'lamellaWidth', 'lm']
      }
    },
    rawDimensionsWithoutLengthConverted: {
      title: modelFieldMessages.rawDimensions,
      format: {
        type: 'conversion_from_many',
        str: '{lamellaThickness} x {lamellaWidth} ',
        keys: [
          { key: 'lamellaThickness', fromUnit: 'millimeters', toUnit: 'inches' },
          { key: 'lamellaWidth', fromUnit: 'millimeters', toUnit: 'inches' }
        ],
        fromUnitLabel: 'mm',
        toUnitLabel: 'in',
        unitType: 'length'
      }
    },
    plannedDimensionsWithoutLengthConverted: {
      title: modelFieldMessages.planedDimensionsSchneider,
      format: {
        type: 'conversion_from_many',
        str: '{lamellaPlannedThickness} x {lamellaPlannedWidth} ',
        keys: [
          { key: 'lamellaPlannedThickness', fromUnit: 'millimeters', toUnit: 'inches' },
          { key: 'lamellaPlannedWidth', fromUnit: 'millimeters', toUnit: 'inches' }
        ],
        fromUnitLabel: 'mm',
        toUnitLabel: 'in',
        unitType: 'length'
      }
    },
    rawDimensionsWithoutLength: {
      title: modelFieldMessages.rawDimensions,
      format: {
        type: 'object_from_many',
        str: '{lamellaThickness} x {lamellaWidth} mm',
        keys: ['lamellaThickness', 'lamellaWidth']
      }
    },
    planedDimensionsWithoutLength: {
      title: modelFieldMessages.planedDimensionsSchneider,
      format: {
        type: 'object_from_many',
        str: '{lamellaPlannedThickness} x {lamellaPlannedWidth} mm',
        keys: ['lamellaPlannedThickness', 'lamellaPlannedWidth']
      }
    },
    numberOfLamellas: {
      key: 'numberOfLamellas',
      type: 'string',
      title: modelFieldMessages.numberOfLamellas
    },
    allSubLengths: {
      key: 'allSubLengths',
      type: 'string',
      title: modelFieldMessages.allSubLengths
    },
    numberOfLayers: {
      key: 'numberOfLayers',
      type: 'string',
      title: modelFieldMessages.numberOfLayers
    },
    lamellaClass: {
      key: 'grade',
      type: 'string',
      title: modelFieldMessages.lamellaClass
    },
    layers: {
      key: 'layers',
      type: 'string',
      title: modelFieldMessages.numberOfLayers
    },
    arrivedFrom: {
      key: 'arrivedFrom',
      type: 'string',
      title: modelFieldMessages.arrivedFrom
    },
    totalLamellaLength: {
      key: 'totalLamellaLength',
      type: 'string',
      title: modelFieldMessages.totalLamellaLength
    },
    numberOfLamellasStacked: {
      key: 'numberOfLamellasStacked',
      type: 'string',
      title: modelFieldMessages.numberOfLamellasPlaned
    },
    numberOfLamellasPlaned: {
      key: 'numberOfLamellasPlaned',
      type: 'string',
      title: modelFieldMessages.numberOfLamellasPlaned
    },
    sortingState: {
      key: 'sortingState',
      type: 'string',
      title: modelFieldMessages.sortingState
    },
    piecesUsed: {
      key: 'piecesUsed',
      type: 'string',
      title: modelFieldMessages.piecesUsed
    },
    packageId: {
      key: 'packageId',
      type: 'string',
      title: modelFieldMessages.packageId
    },
    fetchedFromABF: {
      key: 'fetchedFromABF',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.fetchedFromABF
    },
    canBeSplit: {
      key: 'canBeSplit',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.canBeSplit
    },
    sentToAnte: {
      key: 'sentToAnte',
      type: 'boolean',
      format: {
        type: 'boolean'
      }
    },
    ledinek_id: {
      key: 'ledinek_package_id',
      type: 'string',
      title: modelFieldMessages.led_pckg_id
    },
    articleNumber: {
      key: 'articleNumber',
      type: 'string',
      title: modelFieldMessages.articleNumber
    },
    articleId: {
      key: 'articleId',
      type: 'string',
      title: modelFieldMessages.articleNumber
    },
    pieces: {
      key: 'pieces',
      type: 'string',
      title: modelFieldMessages.pieces
    },
    lmNetto: {
      key: 'lmNetto',
      type: 'string',
      title: modelFieldMessages.lmNetto
    },
    lmBrutto: {
      key: 'lmBrutto',
      type: 'string',
      title: modelFieldMessages.lmBrutto
    },
    sequenceNumber: {
      key: 'sequenceNumber',
      type: 'string',
      title: modelFieldMessages.sequenceNumber
    },
    strengthString: {
      key: 'strengthGradeString',
      type: 'string',
      title: modelFieldMessages.strengthString
    },
    batchId: {
      key: 'batchId',
      type: 'string',
      title: modelFieldMessages.batchId
    },
    consumptionSent: {
      key: 'consumptionSent',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.consumptionSent
    },
    totalSumNeeded: {
      title: modelFieldMessages.total,
      format: {
        type: 'object_from_many',
        str: '{{ {totalSum} / 1000}} m',
        keys: ['totalSum']
      }
    }
  };

  static actions = {
    deleteIncomingPackage: {
      key: 'delete',
      type: 'delete',
      dispatch: 'deleteIncomingPackage',
      modal: {
        modal: true,
        buttonText: 'deleteIncomingPackage',
        key: 'deleteIncomingPackage',
        action: 'deleteIncomingPackage',
        actionData: {
          target: 'backend',
          source: 'packages/incomingpackages/',
          url: '/api/v1/packages/incomingpackages/remove_packages/',
          items: 'selected',
          callType: 'POST'
        }
      }
    },
    deleteSortedPackage: {
      key: 'delete',
      type: 'delete',
      dispatch: 'deleteIncomingPackage',
      modal: {
        modal: true,
        buttonText: 'deleteIncomingPackage',
        key: 'deleteIncomingPackage',
        action: 'deleteIncomingPackage',
        actionData: {
          target: 'backend',
          source: 'packages/sortedpackages/',
          url: '/api/v1/packages/sortedpackages/remove_sorted_packages/',
          items: 'selected',
          callType: 'POST'
        }
      }
    },
    deleteSortedOrderMoelven: {
      key: 'delete',
      type: 'delete',
      dispatch: 'deleteSortedOrderMoleven',
      modal: {
        modal: true,
        buttonText: 'deleteSortedOrderMoleven',
        key: 'deleteSortedOrderMoleven',
        action: 'deleteSortedOrderMoleven',
        actionData: {
          target: 'backend',
          source: 'orders/all/?status=todo',
          url: '/api/v1/orders/sortedorders/remove_sorted_orders_moelven/',
          items: 'selected',
          callType: 'POST'
        }
      }
    },
    deleteSortedOrder: {
      key: 'delete',
      type: 'delete',
      dispatch: 'deleteSortedOrder',
      modal: {
        modal: true,
        buttonText: 'deleteSortedOrder',
        key: 'deleteSortedOrder',
        action: 'deleteSortedOrder',
        actionData: {
          target: 'backend',
          source: 'orders/sortedorders',
          url: '/api/v1/orders/all/remove_sorted_orders/',
          items: 'selected',
          callType: 'POST'
        }
      }
    },
    editIncomingPackage: {
      key: 'edit',
      type: 'edit',
      identifier: 'editIncomingPackage',
      configuration: {
        model: 'packages',
        url: '/api/v1/packages/incomingpackages/'
      }
    },
    editSortedPackage: {
      key: 'edit',
      type: 'edit',
      identifier: 'editSortedPackage',
      configuration: {
        model: 'packages',
        url: '/api/v1/packages/sortedpackages/'
      }
    },
    editSortedPackageV2: {
      key: 'edit',
      type: 'edit',
      identifier: 'editSortedPackage',
      configuration: {
        model: 'sortedPackages',
        url: '/api/v1/packages/sortedpackages/'
      }
    },
    editPackage: {
      adminRequired: false,
      key: 'editPackage',
      format: {
        type: 'action',
        modalTo: '/perspective/loadedpackages/editpackagemodal',
        icon: 'split',
        style: { fontSize: '27px', color: 'black' }
      },
      title: modelFieldMessages.editJD
    },
    editScannedPackage: {
      adminRequired: false,
      key: 'generalEdit',
      additionalParameters: {
        wsAction: 'set-editscannedpackage'
      },
      format: {
        type: 'action',
        modalTo: '/perspective/loadedpackages/editpackagemodal',
        icon: 'split',
        style: { fontSize: '27px', color: 'black' }
      },
      title: modelFieldMessages.editJD
    },
    sendToLine: {
      key: 'sendToLine',
      format: {
        type: 'wsaction',
        icon: 'sendTo',
        identifier: 'send-to-line',
        style: { fontSize: '18px', color: 'black', cursor: 'pointer' }
      },
      title: modelFieldMessages.startOrder
    },
    editMaterialNeeded: {
      adminRequired: false,
      key: 'editPackage',
      additionalParameters: {
        wsAction: 'set-editmaterialneeded' // očitno {key: 'editPackage'} overwrita in se pošilja keyword set-editpackage
      },
      format: {
        type: 'action',
        modalTo: '/perspective/loadedpackages/editpackagemodal',
        icon: 'split',
        style: { fontSize: '27px', color: 'black' }
      },
      title: modelFieldMessages.editComment
    },
    sendPackageScannedAgain: {
      key: 'sendPackageScannedAgain',
      type: 'controlAction',
      dispatch: 'sendPackageScannedAgain',
      format: {
        icon: 'planeIcon',
        style: { fontSize: '27px', color: 'black' }
      },
      adminRequired: false,
      modal: {
        modal: true,
        buttonText: 'sendPackageScannedAgain',
        key: 'sendPackageScannedAgain',
        action: 'sendPackageScannedAgain',
        icon: '',
        title: '',
        body: '',
        actionData: {
          target: 'control',
          source: 'packagesqueue',
          identifier: 'package-scanned',
          items: 'selected',
          callType: 'POST'
        }
      }
    },
    deleteControlPackage: {
      key: 'delete',
      type: 'deletePackage',
      dispatch: 'deletePackage',
      title: modelFieldMessages.deleteTitle,
      modal: {
        modal: true,
        buttonText: 'deletePackage',
        key: 'deletePackage',
        action: 'deletePackage',
        icon: 'deleteIcon',
        actionData: {
          target: 'control',
          source: 'packagesqueue',
          identifier: 'package-loaded-delete',
          items: 'selected',
          callType: 'POST'
        }
      }
    },
    deleteControlScannedPackage: {
      key: 'delete',
      type: 'deletePackage',
      dispatch: 'deletePackage',
      title: modelFieldMessages.deleteTitle,
      modal: {
        modal: true,
        buttonText: 'deletePackage',
        key: 'deletePackage',
        action: 'deletePackage',
        icon: 'deleteIcon',
        actionData: {
          target: 'control',
          source: 'packagesqueue',
          identifier: 'package-scanned-delete',
          items: 'selected',
          callType: 'POST'
        }
      }
    },
    unusedPackageRemaining: {
      key: 'unusedPackageRemaining',
      type: 'unusedPackageRemaining',
      dispatch: 'unusedPackageRemaining',
      modal: {
        modal: true,
        buttonText: 'unusedPackageRemaining',
        key: 'unusedPackageRemaining',
        action: 'unusedPackageRemaining',
        icon: 'deleteIcon',
        actionData: {
          target: 'control',
          source: 'packagesqueue',
          identifier: 'send-unused-package-data',
          items: 'selected',
          callType: 'POST'
        }
      }
    },
    printSticker: {
      key: 'print',
      format: {
        type: 'urlaction',
        action: 'printSticker',
        icon: 'print',
        data: { printer: 'outfeedPrinter', label: 'package_label' },
        style: { fontSize: '18px', color: 'black', cursor: 'pointer' }
      },
      title: modelFieldMessages.print
    },
    printSticker2: {
      key: 'print',
      format: {
        type: 'urlaction',
        action: 'printSticker',
        icon: 'print',
        data: { printer: 'outfeedPrinter2', label: 'package_label2' },
        style: { fontSize: '18px', color: 'black', cursor: 'pointer' }
      },
      title: modelFieldMessages.print
    },
    printStickerOnStacker: {
      key: 'print',
      format: {
        type: 'urlaction',
        action: 'printSticker',
        icon: 'print',
        data: { printer: 'stackingPrinter', label: 'package_label2' },
        style: { fontSize: '18px', color: 'black', cursor: 'pointer' }
      },
      title: modelFieldMessages.print
    },
    printStickerOnStackerFournier: {
      key: 'print',
      format: {
        type: 'wsaction',
        icon: 'print',
        identifier: 'reprint-sticker',
        style: { fontSize: '18px', color: 'black', cursor: 'pointer' }
      },
      title: modelFieldMessages.print
    },
    incomingPackageScannedSim: {
      key: 'scan',
      format: {
        type: 'urlaction',
        action: 'incoming_package_scanned_SIM',
        icon: 'ScannerIcon',
        data: {},
        style: { fontSize: '18px', color: 'black', cursor: 'pointer' }
      },
      title: modelFieldMessages.scan
    },
    sendToLoaded: {
      key: 'print',
      format: {
        type: 'wsaction',
        icon: 'sendTo',
        identifier: 'send-to-loaded',
        style: { fontSize: '18px', color: 'black', cursor: 'pointer' }
      },
      title: modelFieldMessages.sendToLoaded
    },
    syncWithErp: {
      key: 'syncWithErp',
      type: 'controlAction',
      dispatch: 'syncWithErp',
      format: {
        icon: 'SyncIcon',
        style: { fontSize: '27px', color: 'black' }
      },
      adminRequired: false,
      modal: {
        modal: true,
        buttonText: 'syncWithErpTitle',
        key: 'syncWithErp',
        action: 'syncWithErp',
        icon: '',
        title: '',
        body: '',
        actionData: {
          target: 'control',
          source: 'packagesqueue',
          identifier: 'sync-package',
          items: 'selected',
          callType: 'POST'
        }
      }
    }
  };
}

export default IncomingPackage;
